import React, { useState, useEffect } from 'react';
import Sidebar from '../components/SideBar/SideBar';
import Header from '../components/Header/Header';
import PannelRoutes from '../navigations/PannelRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { isObjectEmpty } from '../utils/utils';
import { HitApi } from '../Api/ApiHit';
import { setFloorJson } from '../redux/Actions/FloorAction';
import { SeatSubscription } from '../apollo/SeatSubscription';
import { searchSeat } from '../constant/Constant';

function Panel() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const FloorReducer = useSelector((state) => state.FloorReducer);
  const [idsArr, setIdsArr] = useState([]);
  const [hideSideBar, setHideSideBar] = useState(false);
  const dispatch = useDispatch();

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      console.log("Mobile detected:", mobile); // Debug log
      
      // On mobile, always collapse sidebar and hide it initially
      if (mobile) {
        setIsCollapsed(true);
        setShowMobileSidebar(false);
      } else {
        setShowMobileSidebar(false); // Reset mobile sidebar state on desktop
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  console.log("Panel State:", { 
    isMobile, 
    showMobileSidebar, 
    hideSideBar, 
    isCollapsed 
  }); // Debug log

  if (isObjectEmpty(FloorReducer?.doc)) {
    const json = { page: 1, limit: 10, search: {} };
    // HitApi(json, searchSeat).then((res) => {
    //   if (res?.message === "Seats retrieved successfully") {
    //     console.log('res', res);
        
    //     dispatch(setFloorJson(res.data));
    //     var arr = []
    //     res.data.map((ele, i) => {
    //       arr.push(ele._id)
    //     })
    //     setIdsArr(arr);
    //   }
    // });
  }

  // Handle sidebar toggle for mobile
  const handleSidebarToggle = () => {
    console.log("Sidebar toggle clicked:", { isMobile, showMobileSidebar }); // Debug log
    if (isMobile) {
      setShowMobileSidebar(!showMobileSidebar);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };

  // Handle mobile sidebar close (when clicking outside or navigation)
  const handleMobileSidebarClose = () => {
    console.log("Mobile sidebar close triggered"); // Debug log
    if (isMobile) {
      setShowMobileSidebar(false);
    }
  };

  // Determine if sidebar should be shown
  const shouldShowSidebar = () => {
    const result = !hideSideBar; // Remove mobile condition for now to debug
    console.log("Should show sidebar:", result, { hideSideBar, isMobile, showMobileSidebar }); // Debug log
    return result;
  };

  return (
    <div>
      {idsArr.map((id) => (
        <SeatSubscription key={id} id={id} />
      ))}
      
  
      
      <div className="flex h-screen relative">
        
        {/* Mobile Overlay */}
        {isMobile && showMobileSidebar && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={handleMobileSidebarClose}
          />
        )}

        {/* Sidebar Container - Always render, control visibility with CSS */}
        <div className={`
          fixed left-0 top-0 h-full z-50
          transform transition-transform duration-300 ease-in-out
          ${!shouldShowSidebar() ? '-translate-x-full' : ''}
          ${isMobile ? (showMobileSidebar ? 'translate-x-0' : '-translate-x-full') : 'translate-x-0'}
          ${hideSideBar ? 'hidden' : 'block'}
        `}>
          <Sidebar 
            setHideSideBar={setHideSideBar}
            isCollapsed={isMobile ? false : isCollapsed}
            onToggleCollapse={handleSidebarToggle}
            onMobileClose={handleMobileSidebarClose}
            isMobile={isMobile}
          />
        </div>
        
        {/* Main Content */}
        <div
          className={`
            flex-1 flex flex-col transition-all duration-300 ease-in-out w-full
            ${!isMobile && !hideSideBar ? (isCollapsed ? 'ml-16' : 'ml-64') : ''}
          `}
        >
          <Header 
            hideSideBar={hideSideBar}
            isCollapsed={isCollapsed}
            onToggleCollapse={handleSidebarToggle}
            isMobile={isMobile}
            showMobileSidebar={showMobileSidebar}
          />
          <div className={`${hideSideBar ? "p-0" : "p-5"} flex-1 overflow-auto`}>
            <PannelRoutes />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Panel;